/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TimeZonePickerDefault } from './timezone-picker-default.story';
export { default as TimeZonePickerError } from './timezone-picker-error.story';
export { default as TimeZonePickerFluid } from './timezone-picker-fluid.story';
export { default as TimeZonePickerSizes } from './timezone-picker-sizes.story';
export { default as TimeZonePickerDisabled } from './timezone-picker-disabled.story';
export { default as TimeZonePickerDSTAware } from './timezone-picker-dst-aware.story';
export { default as TimeZonePickerUTCOnly } from './timezone-picker-utc-only.story';
export { default as TimeZonePickerBothMode } from './timezone-picker-both-mode.story';
export { default as TimeZonePickerInDialog } from './timezone-picker-in-dialog.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TimeZonePickerBothModeSourceRaw from './timezone-picker-both-mode.story.tsx?raw';
import TimeZonePickerDefaultSourceRaw from './timezone-picker-default.story.tsx?raw';
import TimeZonePickerDisabledSourceRaw from './timezone-picker-disabled.story.tsx?raw';
import TimeZonePickerDSTAwareSourceRaw from './timezone-picker-dst-aware.story.tsx?raw';
import TimeZonePickerErrorSourceRaw from './timezone-picker-error.story.tsx?raw';
import TimeZonePickerFluidSourceRaw from './timezone-picker-fluid.story.tsx?raw';
import TimeZonePickerInDialogSourceRaw from './timezone-picker-in-dialog.story.tsx?raw';
import TimeZonePickerSizesSourceRaw from './timezone-picker-sizes.story.tsx?raw';
import TimeZonePickerUTCOnlySourceRaw from './timezone-picker-utc-only.story.tsx?raw';

export const TimeZonePickerDefaultSource = removeLicenseHeader(
  TimeZonePickerDefaultSourceRaw,
);
export const TimeZonePickerErrorSource = removeLicenseHeader(
  TimeZonePickerErrorSourceRaw,
);
export const TimeZonePickerFluidSource = removeLicenseHeader(
  TimeZonePickerFluidSourceRaw,
);
export const TimeZonePickerSizesSource = removeLicenseHeader(
  TimeZonePickerSizesSourceRaw,
);
export const TimeZonePickerDisabledSource = removeLicenseHeader(
  TimeZonePickerDisabledSourceRaw,
);
export const TimeZonePickerDSTAwareSource = removeLicenseHeader(
  TimeZonePickerDSTAwareSourceRaw,
);
export const TimeZonePickerUTCOnlySource = removeLicenseHeader(
  TimeZonePickerUTCOnlySourceRaw,
);
export const TimeZonePickerBothModeSource = removeLicenseHeader(
  TimeZonePickerBothModeSourceRaw,
);
export const TimeZonePickerInDialogSource = removeLicenseHeader(
  TimeZonePickerInDialogSourceRaw,
);
